import React, { useState } from "react";
import { Button } from "../../components/button/Button";
import Loader from "../../components/styled-components/loader/loader";
import Base64 from "../../utils/base64";
import axios from "axios";
import ROUTES from "../../config/routes";
import swal from "sweetalert";

export const ForgetPasswordSelect = (props) => {
  const [loading, setLoading] = useState(false);
  const [radioSelect, setRadioSelect] = useState(null);
  const assetPlanetClientName = "asset_planet_resource";
  const assetPlanetClientPassword = "a_p_creds";
  const basicCreds = Base64.btoa(
    assetPlanetClientName + ":" + assetPlanetClientPassword
  );

  const config = {
    headers: {
      "Content-type": "Application/json",
      Authorization: "Basic " + basicCreds,
    },
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setRadioSelect(e.target.value);
  };
  const handleNext = async () => {
    if (radioSelect && radioSelect) {
      const payload = {
        type: radioSelect && radioSelect,
        userName: props && props.data && props.data.userName,
      };
      try {
        setLoading(true);
        const res = await axios.post(
          `${ROUTES.BASE_URL}/auth-service/send-otp`,
          payload,
          config
        );
        setLoading(false);
        if (res.status === 200 && res.data) {
          swal("Success", res.data.message, "success");
          props.stepState(3);
          props.selectedType(radioSelect);
        }
      } catch (error) {
        setLoading(false);
        swal(
          "Oops!",
          error.response && error.response.data && error.response.data.message,
          "error"
        );
      }
    } else {
      swal("Oops!", "Please Select Phone or Email to Recieve OTP ", "error");
    }
  }; 
  return (
    <div style={{ marginTop: "20px" }}>
      <div className="login-card border">
        <h2 className="login-heading">Forgot Password</h2>
        <p style={{color: "rgb(77, 94, 128)", fontFamily:"Poppins", textAlign:"left"}}>
          {" "}
          Select email or phone to receive One-Time Code to Complete password change.
        </p>
        <div style={{ marginTop: "1rem" }}>
          <label class="container1">
            <input
              type="radio"
              id="check"
              name="check"
              value="EMAIL"
              onChange={handleChange}
            />
            <span class="checkmark"></span>
            {props && props.data && props.data.email}
          </label>
          <label class="container1">
            <input
              type="radio"
              id="check1"
              name="check"
              value="PHONE"
              onChange={handleChange}
            />
            <span class="checkmark"></span>
            {props && props.data && props.data.phoneNumber}
          </label>

          <Button
            style={{ background: "#2A3DA3", marginTop: "1rem" }}
            onClick={() => {
              handleNext();
            }}
          >
            Next
          </Button>
          <div
            style={{
              marginTop: "1rem",
              display: "flex",
              justifyContent: "center",
            }}
          ></div>
        </div>
      </div>
      <Loader isLoading={loading}></Loader>
    </div>
  );
};
